export default {
  colors: {
    primary: '#00000096',
    secondary: '#00000069',
    tertiary: '#00000085',
    quaternary: '#000000',
    quinary: '#000000'
  }
};
